import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { TextLink } from "../../../components/buttons/textLink";
import { TextInput } from "../../../components/inputs/textInput";
import { HeaderSubheader } from "../../../components/typography/headerSubheader";
import { useRegisterMemberAccountMutation } from "../../../redux/features/auth/auth.api";
import { memberSignUpSchema } from "../../../validationSchema";

export const SignUpMember = () => {
  const [, setSearchParams] = useSearchParams();

  const [registerMemberAccount, { isLoading: registering }] =
    useRegisterMemberAccountMutation();

  const {
    values,
    errors,
    isValid,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    validationSchema: memberSignUpSchema,
    onSubmit: async (data, { resetForm }) => {
      const payload = {
        FName: data.firstName,
        LName: data.lastName,
        Email: data.email,
        Password: data.password,
      };

      const resp = await registerMemberAccount({
        ...payload,
      });

      if (resp.data?.success) {
        resetForm();
        setSearchParams({ step: "confirm-mail", email: data.email });
      }
    },
  });

  return (
    <div className="w-full">
      <HeaderSubheader
        header="Setup your account"
        subheader="Kindly provide the information below and we’re good to go."
      />

      <form className="mt-6 flex flex-col gap-3" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name={"firstName"}
          value={values.firstName}
          placeholder="First name"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.firstName && touched.firstName ? errors.firstName : ""}
          hasIcon={false}
        />

        <TextInput
          type="text"
          name={"lastName"}
          value={values.lastName}
          placeholder="Last name"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.lastName && touched.lastName ? errors.lastName : ""}
          hasIcon={false}
        />

        <TextInput
          type="text"
          name={"email"}
          value={values.email}
          placeholder="Email address"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.email && touched.email ? errors.email : ""}
          hasIcon={false}
        />

        <TextInput
          type="password"
          name={"password"}
          value={values.password}
          placeholder="Password"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.password && touched.password ? errors.password : ""}
          hasIcon={false}
        />

        <Button
          text="Create Account"
          onClick={() => {}}
          type="submit"
          disabled={!isValid || registering}
          loading={registering}
          className="w-full mt-5 md:mt-3"
        />

        <p className="w-full mt-1 !text-sm text-grey-400">
          Signing up for a cooperative?{" "}
          <TextLink
            to="/auth/sign-up/cooperative"
            text="Register"
            className=""
            onClick={() => {}}
          />{" "}
          a cooperative account
        </p>
      </form>
    </div>
  );
};
